export const AppDataDemo = [
    {
        id: 101,
        subscriptionName: '---------',
        domain: 'demodomain.net',
        timeSubscriptionStart: 1695060000,
        timeSubscriptionEnd: 1695664800,
        status: 'active',
        customerId: 19,
        timeFirstInstallation: 1695664800,
        timeClientUpdate: 1695664800,
        customerInfo: {
            id: 19,
            customerName: 'Kumar Bishojit Paul',
            customerEmail: 'bishojit@gmail.com',
            primaryEmail: 'bishojit@gmail.com',
            customerPhone: '01925363333',
            addressFull: 'Test Address',
            status: 'active'
        },
        demo: true
    },
    {
        id: 102,
        subscriptionName: '---------',
        domain: 'demodomain.net',
        timeSubscriptionStart: 1695060000,
        timeSubscriptionEnd: 1695664800,
        status: 'active',
        customerId: 19,
        timeFirstInstallation: 1695664800,
        timeClientUpdate: 1695664800,
        customerInfo: {
            id: 19,
            customerName: 'Kumar Bishojit Paul',
            customerEmail: 'bishojit@gmail.com',
            primaryEmail: 'bishojit@gmail.com',
            customerPhone: '01925363333',
            addressFull: 'Test Address',
            status: 'active'
        },
        demo: true
    },
    {
        id: 103,
        subscriptionName: '---------',
        domain: 'demodomain.net',
        timeSubscriptionStart: 1695060000,
        timeSubscriptionEnd: 1695664800,
        status: 'active',
        customerId: 19,
        timeFirstInstallation: 1695664800,
        timeClientUpdate: 1695664800,
        customerInfo: {
            id: 19,
            customerName: 'Kumar Bishojit Paul',
            customerEmail: 'bishojit@gmail.com',
            primaryEmail: 'bishojit@gmail.com',
            customerPhone: '01925363333',
            addressFull: 'Test Address',
            status: 'active'
        },
        demo: true
    }
];

export default null;
